<template>
  <div class="elevDetailsMenuList">
    <el-radio-group v-model="timeFrame" @change="changeTimeFrame" size="medium">
      <el-radio-button v-model="timeFrame" label="本日"></el-radio-button>
      <el-radio-button v-model="timeFrame" label="本月"></el-radio-button>
      <el-radio-button v-model="timeFrame" label="本年"></el-radio-button>
    </el-radio-group>

    <div style="width: 95%; margin-top: 10px">
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 100%"
        :clearable="false"
        unlink-panels
        format="yyyy-MM-dd"
        value-format="timestamp"
        :picker-options="pickerOptions"
        @change="timeFrame = ''"
      >
      </el-date-picker>
    </div>
    <div
      style="width: 100%; margin: 20px 0 20px 0"
      v-if="$route.path != '/runTimeStatistics'"
    >
      <el-tree
        :data="treeData"
        style="
          max-height: 400px;
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
        "
        default-expand-all
        node-key="id"
        highlight-current
        ref="tree"
        :default-expanded-keys="defaultKeys"
        :props="defaultProps"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>

    <div class="buttons">
      <el-button type="primary" @click="onSubmit" style="width: 100%"
        >确 认</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      timeFrame: "本日",
      date: [
        new Date(new Date(new Date().toLocaleDateString()).getTime()).getTime(),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ).getTime(),
      ], //时间选择器

      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultData: {}, //默认选中的第一个数据
      defaultKeys: [], //默认打开
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },
  methods: {
    handleNodeClick(data) {
      // console.log(data);
      this.defaultData = data;
    },
    onSubmit() {
      if (
        dateFtt("yyyy-MM-dd", new Date(this.date[1])) ===
        dateFtt("yyyy-MM-dd", new Date())
      ) {
        this.date[1] = new Date(
          dateFtt("yyyy-MM-dd hh:mm:ss", new Date())
        ).getTime();
      } else {
        this.date[1] = new Date(
          dateFtt("yyyy-MM-dd 23:59:59", new Date(this.date[1]))
        ).getTime();
      }
      let dayNum = (this.date[1] - this.date[0]) / (1000 * 60 * 60 * 24);
      if (dayNum >= 366) {
        this.$message.warning("查询时间跨度不能超过一年！");
        return false;
      }
      this.$store.commit("SET_LOADING", true);
      return new Promise(async (resolve) => {
        let res = await api.subsystemGetInfo({
          beginTime: this.date[0],
          endTime: this.date[1],
          id: this.defaultData.id,
        });
        // console.log(res);
        if (res && res.status == 200) {
          this.$store.commit("SET_LOADING", false);
          this.$emit("getAllData", res.data);
        }

        resolve();
      });
    },
    // 获取时间范围变化
    changeTimeFrame() {
      if (this.timeFrame == "本日") {
        let start = new Date(
          new Date(new Date().toLocaleDateString()).getTime()
        );
        let end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.date = [start.getTime(), end.getTime()];
      } else if (this.timeFrame == "本月") {
        let start = new Date(
          new Date(
            new Date(
              dateFtt("yyyy-MM-01 00:00:00", new Date())
            ).toLocaleDateString()
          ).getTime()
        );
        let end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.date = [start.getTime(), end.getTime()];
      } else if (this.timeFrame == "本年") {
        let start = new Date(
          new Date(
            new Date(
              dateFtt("yyyy-01-01 00:00:00", new Date())
            ).toLocaleDateString()
          ).getTime()
        );
        let end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.date = [start.getTime(), end.getTime()];
      }
    },
    async getMenu() {
      let _this = this;
      let res = await api.systemGetTreeData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: "电梯系统",
      });
      // console.log(res);
      if (res.status == 200) {
        this.treeData = [];
        this.treeData.push(res.data);

        function calleArr(array) {
          let data = array[0];
          if (data.children) {
            calleArr(data.children);
          } else {
            _this.defaultData = data;
          }
        }
        calleArr(_this.treeData);
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(_this.defaultData.id);
          this.defaultKeys.push(_this.defaultData.id);
        });
        this.onSubmit();
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.getMenu();
    });
  },
};
</script>

<style lang="scss" scoped>
.elevDetailsMenuList {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;
  ::v-deep .el-form-item__content {
    margin-left: 30px !important;
  }
  ::v-deep .el-form-item {
    margin-bottom: 5px;
  }
  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }
  .buttons {
    width: 55%;
    margin: 0 auto;
  }
}
</style>